import { ISectionContent } from "pages/[tenant]/browse/types";

import api from "shared/infra/services/api";
import { IBillboardHighlight, IBillboardSection } from "shared/types/billboard";

import { captureException, captureMessage } from "@sentry/nextjs";

export const getHighlights = async (
  organizationId?: string,
  onFinishCallback?: () => void,
): Promise<IBillboardHighlight[]> => {
  try {
    const response = await api.get("billboard/highlights", {
      params: {
        org: organizationId,
      },
    });

    return response?.data?.data;
  } catch (error) {
    captureException(error);
    console.log("Error (getHighlights): ", error);
    captureMessage("Error browseGetStaticProp::getHighlights");
    return [];
  } finally {
    if (!!onFinishCallback) onFinishCallback();
  }
};

export const getSection = async (
  organizationId?: string,
  onFinishCallback?: () => void,
): Promise<IBillboardSection[]> => {
  try {
    const response = await api.get("billboard/sections?perPage=100&page=1", {
      params: {
        "order[0][index]": "position",
        "order[0][value]": "desc",
        org: organizationId,
      },
    });

    return response.data.data;
  } catch (error) {
    captureException(error);
    captureMessage("Error browseGetStaticProp::getSection");
    console.log("Error (getSection): ", error);
    return [];
  } finally {
    if (!!onFinishCallback) onFinishCallback();
  }
};

export const getSectionContent = async ({
  sectionId,
  organizationId = "",
  onFinishCallback = () => {
    return;
  },
}): Promise<ISectionContent[]> => {
  try {
    const response = await api.get(
      `billboard/sections/${sectionId}/content?per_page=50&page=1`,
      {
        params: {
          org: organizationId,
        },
      },
    );

    return response?.data?.data;
  } catch (error) {
    captureException(error);
    captureMessage("Error browseGetStaticProp::getSectionContent");
    console.log("Error (getSectionContent): ", error);
    return [];
  } finally {
    if (!!onFinishCallback) onFinishCallback();
  }
};
